import { InjectionToken } from '@angular/core';

export const NB_STEPPER = new InjectionToken('Nebular Stepper Component');
